import { useEffect, useState } from "react";
import { t } from "@/lib/i18n";

const KEY = "ks_splash_seen";

export default function SplashLoader() {
  const [phase, setPhase] = useState(() => (sessionStorage.getItem(KEY) ? "done" : "show"));

  useEffect(() => {
    document.getElementById("boot-splash")?.remove();
    if (phase !== "show") return;
    const t1 = setTimeout(() => setPhase("out"), 1500);
    const t2 = setTimeout(() => { setPhase("done"); sessionStorage.setItem(KEY, "1"); }, 2000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [phase]);

  if (phase === "done") return null;
  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[var(--paper)] jali-bg ${phase === "out" ? "splash-out" : ""}`}
      data-testid="splash-loader"
      aria-hidden="true"
    >
      <div className="relative w-36 h-36 sm:w-44 sm:h-44">
        <span className="splash-ring" />
        <span className="splash-ring d2" />
        <img src="/logo-round-320.png" alt={t("Kindsaver")} className="splash-logo relative w-full h-full rounded-full shadow-[0_20px_50px_-20px_rgba(46,125,50,.6)]" />
      </div>
      <p className="mt-8 text-xs tracking-[0.3em] uppercase text-[var(--ink-soft)] fade-up" style={{ animationDelay: "400ms" }}>
        {t("Kind · Clean · Bold")}
      </p>
    </div>
  );
}
